// extracted by mini-css-extract-plugin
module.exports = {"basketul":"styles_basketul__-tPDz","basketli":"styles_basketli__1H3-e","basketlink":"styles_basketlink__1NTvx","favorremovebtn":"styles_favorremovebtn__1-Sy0"};